import { render, staticRenderFns } from "./performanceindicatortable.vue?vue&type=template&id=2c5709c8"
import script from "./performanceindicatortable.vue?vue&type=script&lang=js"
export * from "./performanceindicatortable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports